export const exportPPT = `
  mutation ExportPPT($input: ExportPPTInput!) {
    exportPPT(input: $input)
  }
`;
